import { styled } from "@mui/material/styles";
import { Link, LinkProps } from "react-router-dom";
import { typographyStyles } from "./Typography";

interface NavLinkProps extends Omit<LinkProps, "to"> {
  to: string;
  active?: boolean;
  children: React.ReactNode;
}

const StyledNavLink = styled(Link, {
  shouldForwardProp: (prop) => prop !== 'isActive',
})<{ isActive?: boolean }>(({ isActive }) => ({
  ...typographyStyles.p2,
  color: isActive ? "var(--text-white)" : "var(--text-secondary)",
  padding: "12px",
  textTransform: "none",
  textDecoration: "none",
  display: "inline-block",
  position: "relative",
  transition: "color 0.2s ease, font-weight 0.2s ease",

  "&:hover": {
    textDecoration: "underline",
  },
}));

export const NavLink = ({ to, active, children, ...props }: NavLinkProps) => {
  return (
    <StyledNavLink to={to} isActive={active} {...props}>
      {children}
    </StyledNavLink>
  );
};
